import PropTypes from 'prop-types';
import {
  OrientationShape,
  PathFuncShape,
} from '../propTypes';

export const defaultProps ={
  onClick: () => {},
  onMouseOver: () => {},
  onMouseOut: () => {},
};

export const propTypes = {
  linkData: PropTypes.shape({
    source: PropTypes.object.isRequired, // d3-hierarchy Node
    target: PropTypes.object.isRequired, // d3-hierarchy Node
  }),
  orientation: OrientationShape,
  pathFunc: PathFuncShape,
  pathClassFunc: PropTypes.func,
  enableLegacyTransitions: PropTypes.bool,
  transitionDuration: PropTypes.number,
  onClick: PropTypes.func.isRequired,
  onMouseOver: PropTypes.func.isRequired,
  onMouseOut: PropTypes.func.isRequired,
};
